module.exports = __webpack_public_path__ + "components/flag/static/square/py-c376b9636a8980f42a44fa3e77423fe6.svg";